// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "groupfolders-" + chunkId + ".js?v=" + {"vendors-node_modules_vue-material-design-icons_Cancel_vue-node_modules_vue-material-design-ic-4d802c":"e51542e9a835d8b5485c","sharing":"b0a5d70eb3e13297ab40","vendors-node_modules_rehype-highlight_index_js":"44cad31fb28d26228249"}[chunkId] + "";
};